var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPictoCheckmark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "m4mx8ur4ea"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.003922 0 0 0 0 0.588235 0 0 0 0 0.878431 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "0mcl60bt5b"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.000000 0 0 0 0 0.662745 0 0 0 0 0.992157 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.5 1.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "",
    cx: 10.5,
    cy: 10.5,
    r: 9.395
  }), /*#__PURE__*/React.createElement("g", {
    filter: "",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.253.69A10.475 10.475 0 0 0 10.5 0C4.701 0 0 4.701 0 10.5S4.701 21 10.5 21 21 16.299 21 10.5",
    stroke: "#0196E0",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#0196e0",
    strokeWidth: 2,
    d: "m5.77 10.794 4.911 4.912 12.27-12.27"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoCheckmark);
export default __webpack_public_path__ + "static/media/PictoCheckmark.3891616e9cdc3707887c96f6f338764e.svg";
export { ForwardRef as ReactComponent };